import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Inventory
export const addInventory = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-inventory`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// update Inventory
export const updateInventory = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-inventory/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// delete Inventory
export const deleteInventory = async (ROWID) => {
  console.log({ ROWID });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-inventory/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};

// total count
export const countInventory = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/count-inventory`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Inventory by ID
export const getInventoryListById = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getbyid-inventory/${id}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
